import PropTypes from 'prop-types';
import s from './CatsCollection.module.css';

import { addFavorites, removeFavorites } from 'services/API/API';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import ClipLoader from 'react-spinners/ClipLoader';
import { CatCard } from './CatCard';

const CatsCollection = ({ images, destination, actualSyleLabelHover }) => {
  const { pathname } = useLocation();
  const [favouritesId, setFavouritesId] = useState(
    localStorage.getItem('favouritesId')
      ? JSON.parse(localStorage.getItem('favouritesId'))
      : []
  );
  const [newImages, setNewImages] = useState(images);
  const [favouritesImages, setFaouvoritesImages] = useState([]);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    images.map(({ image_id }) => {
      setFavouritesId(prev => [...prev, image_id]);
      return image_id;
    });

    setFaouvoritesImages(images);
    addFavotitesIndicator(images, favouritesId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images]);

  useEffect(() => {
    localStorage.setItem('logs', JSON.stringify(logs));
  }, [logs]);

  useEffect(() => {
    setLoading(true);
    if (newImages.length) {
      setLoading(false);
    }
  }, [newImages]);

  function addFavotitesIndicator(images, favouritesId) {
    const newImages = images.map(element => {
      if (favouritesId.includes(element.id)) {
        return { ...element, isActive: true };
      } else {
        return { ...element, isActive: false };
      }
    });
    setNewImages(newImages);
  }

  function getBreedName(cat_id) {
    const infoAboutCat = newImages.filter(({ id }) => id === cat_id);
    const breedName = infoAboutCat[0].breeds[0]
      ? infoAboutCat[0].breeds[0].name
      : 'No breed name';
    return breedName;
  }

  const handlerClick = (e, idCollection) => {
    if (destination === 'breed') {
      return;
    }

    const imageInFavorites = favouritesImages.find(
      ({ image_id }) => image_id === idCollection
    );

    if (imageInFavorites) {
      console.log('is present');
      const imageInImages = newImages.find(({ id }) => {
        return id === idCollection;
      });

      imageInImages.isActive = false;

      const originalFavorites = favouritesImages.find(
        ({ image_id }) => image_id === idCollection
      );

      const indexInFavorites = favouritesImages.indexOf(originalFavorites);

      setFaouvoritesImages(prev => {
        prev.splice(indexInFavorites, 1);
        return [...prev];
      });

      const indexChanged = newImages.indexOf(imageInImages);

      setNewImages(prev => {
        prev.splice(indexChanged, 1, imageInImages);
        return [...prev];
      });

      setLogs(prev => [...prev, imageInImages.id]);

      try {
        removeFavorites(imageInFavorites.id);
      } catch (err) {
        console.log(err);
      }
    } else {
      console.log('not present');
      addFavorites(idCollection)
        .then(({ data }) =>
          setFaouvoritesImages(prev => [
            ...prev,
            { image_id: idCollection, id: data.id },
          ])
        )
        .catch(err => console.log(err));

      const imageChanged = newImages.find(({ id }) => id === idCollection);

      imageChanged.isActive = true;
      const indexChanged = newImages.indexOf(imageChanged);
      setNewImages(prev => {
        prev.splice(indexChanged, 1, imageChanged);
        return [...prev];
      });
    }
  };

  const override: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
  };

  return (
    <div>
      {loading ? (
        <div className={s.spiner}>
          <ClipLoader color={'#FF868E'} size={50} cssOverride={override} />
        </div>
      ) : (
        <div className={s.collection}>
          {newImages.map(({ url, id, isActive }, index) => {
            const path = destination === 'breed' ? `/breeds/${id}` : pathname;

            return (
              <CatCard
                url={url}
                id={id}
                isActive={isActive}
                index={index}
                path={path}
                destination={destination}
                actualSyleLabelHover={actualSyleLabelHover}
                getBreedName={getBreedName}
                handlerClick={handlerClick}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export { CatsCollection };

CatsCollection.propTypes = {
  images: PropTypes.array.isRequired,
  destination: PropTypes.string,
};
